module.exports = `
<div class="modal-content policy-font">
    <div class="modal-body">
        <p class=MsoNormal align=center style='margin-bottom:6.0pt;text-align:center;
line-height:115%;background:white'><b><span style='font-size:12.0pt;line-height:
115%;font-family:"Source Sans Pro","sans-serif"'>Üyelik Sözleşmesi</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Madde 1 - Taraflar</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>İşbu Üyelik Sözleşmesi ve ekleri (“<b>Sözleşme</b>”),
Küçükbakkalköy Mahallesi, Işıklar Caddesi No: 30/6 Ataşehir İstanbul adresinde
faaliyet gösteren İstanbul Ticaret Sicil Müdürlüğüne 112749-5 sicil numarası
ile kayıtlı OtoSor Otomotiv Anonim Şirketi (Mersis No: 0649079090300001)
(bundan böyle&nbsp;<b>“OtoSor”&nbsp;</b>olarak anılacaktır) ile&nbsp;</span><span
                style='font-family:"Source Sans Pro","sans-serif"'><a
                href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
sitesinden ilan görüntülemek amacı ile işbu metni kabul ettiğine onay veren
gerçek veya tüzel kişi veya kurum (bundan böyle “<b>Kullanıcı</b>” anılacaktır)
arasında üye kayıt aşamasında yapılmıştır.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Madde 2 – Sözleşmenin Konusu ve
Akdedilmesi</span></b></p>

        <ol style='margin-top:0cm' start=1 type=1>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>İşbu Sözleşme,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesinde sunulan hizmetlerden yararlanmaya ilişkin şart ve koşulların
     belirlenmesine ilişkindir. Kullanıcı, işbu Sözleşme hükümlerini kabul
     etmekle, web sitesi içinde yer alan kullanıma, üyeliğe ve hizmetlere
     ilişkin OtoSor tarafından açıklanan her türlü beyana uygun davranacağını kabul
     ve taahhüt etmektedir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcı’nın&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesine üyeliği “üyelik formunu” eksiksiz doldurmanızın ardından aktif
     hale gelecektir. Bu forma aktarılan bilgilerin doğruluğunu üyelik
     isteğinde bulunan Kullanıcı kayıtsız şartsız taahhüt eder. Üyelik başvuru
     formuna bilgi girişi yaparken, bilgi formunda istenilen hususların
     eksiksiz, doğru ve açık bir biçimde doldurulması zorunludur.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcı, işbu Sözleşme’nin
     tamamını okuduğunu, içeriğini tamamıyla anladığını ve tüm maddelerini
     kayıtsız şartsız kabul ettiğini ve onayladığını peşinen taahhüt eder.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Bu üyelik ilişkisi sanal bir
     ortamda oluştuğu için, Kullanıcı’nın işbu Sözleşme’yi kabul ettiğine dair
     seçeneği tıklaması ile işbu Sözleşme akdedilmiş olur.</span></li>
        </ol>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Madde 3 – Web Sitesinin Kullanımı
ve Üyelik</span></b></p>

        <ol style='margin-top:0cm' start=1 type=1>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcı tarafından&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesine görsel, içerik ve bilgi yüklenmesi halinde OtoSor’un onayının
     ardından web sitesinde yayımlanacaktır. Kullanıcı, kendisi tarafından
     sağlanan görsel, bilgi ve içeriklerin doğru, güncel ve hukuka uygun
     olmasından sorumludur. OtoSor, Kullanıcı tarafından yüklenerek web
     sitesinde yayımlanan bilgilerin ve içeriklerin doğruluğunu, hukuka uygun
     ve/veya güncel olduğunu araştırmakla yükümlü ve sorumlu değildir. Ayrıca,
     söz konusu bilgi ve içeriklerin yanlış veya hatalı olmasından veya
     yayınlanmasından dolayı ortaya çıkacak herhangi bir zarardan sorumlu
     tutulamaz. Kullanıcı, kendisi tarafından sağlanan bilgi veya içerik sebebi
     ile OtoSor’un herhangi bir zarara uğraması halinde, ilk talebini müteakip
     derhal OtoSor’u tazmin edecektir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><a name="_Hlk512505787"><span style='font-size:
     12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>OtoSor,&nbsp;</span></a><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='color:windowtext'>www.otosor.com.tr</span></a>&nbsp;web
     sitesini görsel, içerik ve bilgi yükleyecek olan Kullanıcı’nın sadece işbu
     Sözleşme’nin 3.1. maddesi uyarınca OtoSor’un onayı ile görsel, içerik ve
     bilgi sağlaması ve ilanları görüntülemesi amacıyla,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesini ve ara yüzlerini kullanmasına izin vermektedir. Belirtilenin dışında
     bir amaçla veri tabanı üzerinden içerik ve ilanlara ulaşılması, (hukuka ve
     usulüne uygun olarak&nbsp;</span><span style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;üzerindeki
     içerik ve ilanlara doğrudan link verilmesi hali ve OtoSor’a
     özgülenebilecek olanlar dışındaki Kullanıcı tarafından OtoSor’a sağlanan
     görsel, içerik ve bilginin kendisi veya yetkili temsilcisi tarafından
     kullanılması hariç olmak üzere) ilanların tamamen veya&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesine özgülenen içerikler ile birlikte kısmen kopyalanması, bunların
     başka mecralarda doğrudan veya dolaylı olarak yayımlanması, derlenmesi,
     çoğaltılması, işlenmesi, başka veri tabanlarına aktarılması, bu veri
     tabanından üçüncü kişilerin erişimine ve kullanımına açılması ve benzer
     fiillerin işlenmesine OtoSor tarafından izin verilmemekte ve rıza
     gösterilmemektedir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>OtoSor ile Kullanıcı, tamamen
     bağımsız taraflardır. OtoSor ile Kullanıcı arasında herhangi bir iş
     ortaklığı ve/veya işçi/işveren ilişkisi bulunmamaktadır. Aksi açıkça
     yazılı olarak kararlaştırılmadıkça, Kullanıcı, OtoSor’un şubesi, bayisi,
     acentesi, temsilcisi, distribütörü ve/veya vekili değildir ve/veya
     Taraflar arasında herhangi bir şekilde iş ortaklığı bulunmamaktadır.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;siyasi
     amaçlı veya başkalarına saldırı amaçlı kullanılamaz. OtoSor,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;üzerinde
     hileli, siyasi ve dini amaçlı yanıltmaya yönelik eksik ve/veya yanlış
     beyanda bulunan Kullanıcılar’ı tek taraflı olarak ve uyarıda bulunmadan
     geçici ve/veya süresiz olarak üyeliklerine son vermek hakkına haizdir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>OtoSor, sebep belirtmeksizin
     istediği Kullanıcı’nın üyeliğine son verme hak ve yetkisine sahiptir.
     Üyeliğine son verilen Kullanıcılar’ın üyelik bilgileri OtoSor tarafından
     saklanacaktır. Üyeliklerine son verilen Kullanıcılar, OtoSor’a başvurmak
     suretiyle üyeliklerini yenileyebilirler.</span></li>
        </ol>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Madde 4 – Tarafların Hak ve
Yükümlülükleri</span></b></p>

        <ol style='margin-top:0cm' start=1 type=1>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>OtoSor, önceden bir bildirime
     veya her hangi bir kimsenin iznine ihtiyaç duymaksızın,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesinin kullanım amacını, şeklini ve usullerini, özelliklerini,
     yapısını, fonksiyonlarını, içeriğini, verilen hizmetleri değiştirebilir,
     Kullanıcı’dan bilgi ve belgeler talep edebilir, web sitesini iptal
     edebilir, işletilmesini askıya alabilir, Kullanıcı’nın web sitesini
     kullanmasını engelleyebilir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Teknik aksaklıklardan veya
     üçüncü kişilerin eylem ve işlemlerinden kaynaklanan sorunlardan dolayı
     OtoSor sorumlu değildir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>OtoSor,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;üzerinden
     ilanı verilen ürünlerin ayıpsız olduğunu veya benzer diğer hususları
     garanti etmez.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>OtoSor, Kullanıcı’ların
     ve/veya&nbsp;</span><span style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesinin tüm üyelerinin birbirleri arasındaki ilişkiler nedeniyle hiçbir
     şekilde sorumlu tutulamaz.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesinde görsel, bilgi, belge veya herhangi bir veri girişi yapan Kullanıcı’lar,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;üzerinden
     haksız rekabete neden olabilecek, diğer üyelere zarar verebilecek,
     mevzuata ve işbu Sözleşmeye aykırılık teşkil edebilecek herhangi bir
     içerik paylaşmayacağını, belirtilen niteliklerde bir işlem yapmayacağını
     kabul, beyan ve taahhüt eder. Ayrıca, gümrük, ihracat, ithalat mevzuatı
     ile standartları ve kambiyo dahil yürürlükteki tüm mevzuata uygun
     davranacağını kabul, beyan ve taahhüt eder. Kullanıcı’nın işbu hükme
     aykırı davranması halinde OtoSor’un hiçbir sorumluluğu bulunmayacaktır.
     Kullanıcı’nın işbu Sözleşme’ye veya mevzuat hükümlerine aykırı davranış
     ve/veya işlemleri nedeniyle, OtoSor’un her hangi bir zarara uğraması veya
     ödeme yapma veya diğer bir talebi yerine getirmek durumunda kalması
     halinde, Kullanıcı, OtoSor’un talebinin ardından OtoSor’u derhal tazmin
     edecektir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcı,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;üzerinden
     kullandığı &quot;kullanıcı adı&quot; ve &quot;şifre&quot;nin güvenliğinin,
     münferiden kendi sorumluluğunda olduğunu kabul, beyan ve taahhüt
     etmektedir. Kullanıcı, OtoSor’a sunduğu bilgilerin güncel, tam, doğru ve
     usulüne uygun olmasından sorumludur. İşbu madde uyarınca OtoSor’un
     herhangi bir sorumluluğu bulunmamaktadır.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>OtoSor hiçbir şekilde sürekli,
     kesintisiz ve güvenli hizmet vereceğini garanti veya taahhüt edemez.
     OtoSor,&nbsp;</span><span style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;ve
     dahilindeki sistemin kesintisiz işleyeceği veya belli ihtiyaçları
     karşılayacağı yönünde herhangi bir taahhütte bulunmamaktadır. Bu
     doğrultuda, OtoSor, açıkça ve yazılı olarak taahhüt ettiği hususlar
     haricinde, Kullanıcılar’a karşı herhangi bir sorumluluğu bulunmamaktadır.
     Kullanıcı, kendisinin ve/veya üçüncü kişilerin zarara uğradığı veya
     haklarının ihlal edildiği iddiası ile OtoSor’dan hiçbir talepte bulunamaz</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcı OtoSor’un mevzuat
     uyarıca resmi makamlara açıklama yapmakla yükümlü olduğu durumlarda;
     kendisine ait gizli veya kişisel nitelikli olabilecek bilgileri resmi
     makamlara açıklamaya yetkili olduğunu, bu sebeple OtoSor’dan tazminat veya
     herhangi bir ad altında ödeme talep etmeyeceğini kabul, beyan ve taahhüt
     etmektedir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcı,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><u><span
                    style='font-size:12.0pt;line-height:115%'>www.otosor.com.tr’d</span></u></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>e
     yayımlanan ilanlar nedeniyle alenileşmiş olan kişisel verilerinin diğer
     arama motorları veya benzer verileri indeksleyen sistemler tarafından
     kaydedilmesi, işlenmesi, arama sonuçlarında çıkarılması gibi durumlar için
     OtoSor’un herhangi bir katkısının olmadığını ve kişisel verilerinin
     indesklenmek veya sair yöntemlerle aramaya mahsus yapılandırılmış sistemlerde
     herhangi bir şekil ve surette işlenmesi veya aktarılmasından dolayı
     OtoSor’un herhangi bir sorumluluğunun olmadığını, taleplerini arama motoru
     veya arama sistemleri, indeskleme sistemleri işleten gerçek ve/veya tüzel
     kişilere yöneltmeyi kabul, beyan ve taahhüt eder.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Veri sorumlusu sıfatını haiz
     olması halinde Kullanıcı, </span><span style='font-size:12.0pt;line-height:
     115%;font-family:"Source Sans Pro","sans-serif"'>işbu Sözleşme
     çerçevesinde kişisel verilerin işlenmesine ilişkin tüm süreçlerinin 6698
     sayılı Kişisel Verilerin Korunması Kanunu ile ikincil düzenlemelere (“<b>KVKK
     Mevzuatı</b>”) uygun olduğunu ve ilgili kişilerin kişisel verilerinin
     işlenmesine ve OtoSor’a aktarılmasına yönelik olanlar ile kişisel verilerin
     güvenliğini temin etmeye yönelik gerekli tüm teknik ve idari tedbirleri
     almak başta olmak üzere KVKK Mevzuatı’ndan kaynaklanan tüm
     yükümlülüklerini yerine getirdiğini kabul, beyan ve taahhüt eder.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Veri sorumlusu sıfatını haiz
     Kullanıcı tarafından</span><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'> OtoSor’un kendisine ait
     İnternet sitesinde yayınlanmak üzere OtoSor ile paylaşılan araç fotoğraflarında
     yer alan gerçek kişi görüntüsü ve plaka numarası dahil ancak bunlarla
     sınırlı olmayan kişisel veri teşkil eden tüm veriler bakımından, ilgili
     kişileri aydınlatma ve gerektiğinde bu kişilerden açık rıza alma
     yükümlülüğü ile KVKK Mevzuatı’nda yer alan sair yükümlülüklerin yerine
     getirilmesinden Kullanıcı münhasıran sorumludur.</span></li>
        </ol>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Madde 5 – Fikri Mülkiyet Hakları</span></b></p>

        <ol style='margin-top:0cm' start=1 type=1>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcılar, OtoSor’un
     sunduğu hizmetleri, OtoSor’un ve&nbsp;</span><span style='font-family:
     "Source Sans Pro","sans-serif"'><a href="http://www.otosor.com.tr/"><span
                    style='font-size:12.0pt;line-height:115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;üzerinde
     yer alan her türlü görsel, içerik ve bilgileri ve OtoSor’un Fikir ve Sanat
     Eserleri Kanun’u kapsamında eser sayılabilecek unsurlarını ve telif
     haklarına tabi çalışmalarını satmak, işlemek, paylaşmak, dağıtmak, sergilemek
     veya başkasının&nbsp;</span><span style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;üzerinden
     OtoSor tarafından sağlanan hizmetlere erişmesi veya kullanmasına izin
     vermek hakkına sahip değildir. Kullanıcılar, OtoSor tarafından açıkça izin
     verilen haller haricinde OtoSor’un Fikir ve Sanat Eserleri Kanun’u kapsamında
     eser sayılabilecek unsurlarını ve telif haklarına tabi çalışmalarını
     çoğaltamaz, işleyemez, dağıtamaz veya bunlardan türemiş çalışmalar
     yapamaz.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcı, OtoSor’un ve diğer
     üçüncü kişilerin fikri mülkiyet haklarını ihlal etmemeyi, bu hakları
     kullanmamayı, kopyalamamayı, bu hakları dolaylı da olsa ihlal etmemeyi,
     üçüncü kişilerin her hangi bir fikri mülkiyet haklarının ihlal edildiğine
     ilişkin talepte bulunmaları halinde OtoSor’u, ilk talebini müteakip 3 iş
     günü içerisinde tazmin etmeyi beyan, kabul ve taahhüt eder. Kullanıcı, web
     sitesini sadece kendi ihtiyacı için kullanabilir. Web sitesini gelir elde
     etmek amacıyla kullanamaz veya başkalarına kullandıramaz.</span></li>
        </ol>

        <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;
margin-left:36.0pt;text-align:justify;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Madde 6 - Mücbir Sebep</span></b></p>

        <ol style='margin-top:0cm' start=1 type=1>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Hukuken mücbir sebep sayılan
     tüm durumlarda, OtoSor, işbu Sözleşme kapsamındaki yükümlülüklerini kısmen
     veya tamamen yerine getiremeyebilir, OtoSor’un kontrolü dışında,&nbsp;</span><span
                    style='font-family:"Source Sans Pro","sans-serif"'><a
                    href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
     115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                    style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
     sitesinin veya internetin kullanımından (elektrik kesintisi, donanım
     problemleri, alt yapı sorunları, doğal afetler, vs. gibi) dolayı birçok
     sorunlar yaşanabilir. Bu halde, OtoSor’dan herhangi bir ad altında
     tazminat talep edilemeyecektir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Mücbir sebep terimi; siber
     saldırı, terör, doğal afet, isyan, savaş, grev, iletişim sorunları,
     altyapı ve internet arızaları, sisteme ilişkin iyileştirme veya
     yenileştirme çalışmaları ve bu sebeple meydana gelebilecek arızalar,
     elektrik kesintisi ve kötü hava koşulları da dahil ve fakat bunlarla
     sınırlı olmamak kaydıyla ilgili OtoSor’un kontrolünde olmayan ve/veya
     gerekli ve makul özeni göstermesine rağmen kaçınamayacağı haller olarak
     yorumlanacaktır.</span></li>
        </ol>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Madde 7 – Diğer Hükümler</span></b></p>

        <ol style='margin-top:0cm' start=1 type=1>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>İşbu Sözleşme ekleri ile bir
     bütün oluşturmaktadır ve beraber yorumlanmaktadır.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>OtoSor, yasal tebligat
     yollarının yanı sıra, işbu Sözleşme kapsamında Kullanıcı’ya yapacağı
     bildirim, ihbar ve ihtarları elektronik haberleşme kanallarıyla
     gönderebilir. Bu şekilde yapılan tebligatlar geçerli bir tebligatın tüm
     sonuçlarını doğurur.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>İşbu Sözleşme süresiz olarak
     düzenlenmiştir. Taraflardan her biri yazılı bir bildirimde bulunarak,
     dilediği zaman işbu Sözleşme’yi fesih hakkına sahiptir.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Kullanıcı, işbu Sözleşme’yi
     veya işbu Sözleşme kapsamındaki hak ve yükümlülüklerini kısmen veya
     tamamen herhangi bir üçüncü kişiye devredemez.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>İşbu Sözleşme Türk hukukuna
     tabidir. Taraflar arasında işbu Sözleşme’den kaynaklanacak uyuşmazlıklarda
     İstanbul Anadolu mahkemeleri ve icra daireleri münhasır olarak yetkilidir.
     İşbu Sözleşme’den doğabilecek tüm uyuşmazlıklarda, OtoSor’un defter ve
     kayıtları esas alınacaktır.</span></li>
        </ol>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><b><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>EK
– 1</span></b><span style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>:
Açık Rıza Beyanı<br>
<b>EK – 2</b>: Çerez Politikası</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><b><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>Ek
- 1</span></b><span style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'><br>
<b>Kişisel Verilere İlişkin Açık Rıza Beyanı</b></span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>OtoSor Otomotiv Anonim Şirketi’ne
(“<b>Şirket</b>”)&nbsp;</span><span style='font-family:"Source Sans Pro","sans-serif"'><a
                href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
sitesine üyelik kapsamında kişisel verilerimi vermekteyim. Şirket’in tarafımdan
hangi kişisel verilerimi aldığını ve ayrıca dilediğim zaman bu hususu
Şirket’ten öğrenebileceğimi/teyit edebileceğimi bilmekteyim. Bu doğrultuda KVKK
mevzuatı kapsamında haklarıma ve kişisel verilerimin işlenmesine dair
bilgilendirilmem amacıyla tarafıma sunulan KVKK Aydınlatma Formu vasıtasıyla
Şirket tarafından tam ve eksiksiz olarak bilgilendirildiğimi beyan ederim.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Kişisel verilerimin, web sitesine
üyelik kapsamında oluşan ilişkilerinde tarafların hak ve yükümlülüklerini ifa
edebilmesi adına ve KVKK Aydınlatma Formu doğrultusunda toplanmasına,
depolanmasına, kullanılmasına, (aktarım yapılacak gerçek ya da tüzel kişinin
bulunduğu yer, kişisel verilere dair ikamet ettiğim ülke hukukunun gerektirdiği
yeterli korumayı sağlamayan ülkelerde olsa dahi) aktarılmasına, muhafaza
edilmesine, bir diğer ifadeyle işlenmesine, Şirket ile aramızda herhangi bir
hukuki ilişki kurulmasa dahi, özgür iradem çerçevesinde açık rıza veriyorum ve
geri çekmediğim sürece işbu açık rızamın tam olarak geçerli kalacağına
muvafakat ediyorum.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><b><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>EK
2</span></b><span style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'><br>
<b>Çerez Politikası</b></span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-family:"Source Sans Pro","sans-serif"'><a
                href="http://www.otosor.com.tr/"><span style='font-size:12.0pt;line-height:
115%;color:windowtext'>www.otosor.com.tr</span></a></span><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;web
sitesinin çerez politikasına ilişkin işbu belge (“<b>Politika</b>”),
Küçükbakkalköy Mahallesi, Işıklar Caddesi No:30/6 Ataşehir/İstanbul adresinde
faaliyet gösteren İstanbul Ticaret Sicil Müdürlüğüne 112749-5 sicil numarası
ile kayıtlı OtoSor Otomotiv Anonim Şirketi (Mersis No: 0649079090300001) (“<b>OtoSor</b>”)
tarafından hazırlanmıştır.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Sistemle ilgili sorunların
tanımlanması ve Web Sitesi'nde çıkabilecek sorunların derhal giderilebilmesi
için, OtoSor, kullanıcıların IP adresini tespit etmekte ve kullanmaktadır. IP
adresleri, kullanıcıları genel bir şekilde tanımlamak ve kapsamlı demografik
bilgi toplamak amacıyla da kullanılabilir.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>İşbu Politika’yı kabul etmek ile
birlikte kişisel bilgilerinizin toplanmasına, işlenmesine, üçüncü kişiler ile
paylaşılmasına, OtoSor tarafından kişisel bilgilerin muhafaza edilmesine,
kişisel bilgilerinizin güvenliğinin OtoSor tarafından sağlanacağına, gerektiği
takdirde kişisel bilgilerinizin KVKK Aydınlatma Formu kapsamında belirtilen
üçüncü kişiler ile paylaşılmasına rıza göstermektesiniz.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>OtoSor tarafından talep edilen
bilgiler veya kullanıcı tarafından sağlanan bilgiler veya web sitesi üzerinden
yapılan işlemlerle ilgili bilgiler OtoSor ve KVKK Aydınlatma Formu kapsamında
belirtilen işbirliği içinde olduğu kişiler tarafından kullanıcının kimliği ifşa
edilmeden çeşitli istatistiksel değerlendirmeler, veri tabanı oluşturma ve
pazar araştırmalarında kullanılabilir.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>OtoSor web sitesindeki çerez
politikası uyarısında yer alan “Çerez kullanımını onaylıyorum.” butonuna
tıklayarak OtoSor’un cihazınızda çerez kullanmasına onay veriyorsunuz. Eğer
OtoSor’un cihazınızda çerez kullanmasını istemiyorsanız ilerlemeden önce lütfen
“Çerez kullanımını reddediyorum.” butonuna tıklayın.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Bununla birlikte, başta “Çerez
kullanımını onaylıyorum” butonunu tıklamış olsanız bile, dilediğiniz zaman
çerez kullanımını engellemeyi ve çerezleri silmeyi tercih edebilirsiniz.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Çerez veya ‘cookie’ nedir?</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>‘Cookie’ ya da çerezlerin internet
tarayıcınızın cihazınıza yerleştirdiği küçük birer veri dosyası olduğu
düşünülebilir. Çerezlerin görevi, kullanıcının yeniden ziyaret ettiğini siteye
bildirmektir. Tarayıcı ayarlarının, giriş bilgilerinin ve sistem bilgisinin
hatırlanması, kullanıcıya hizmet odaklı ve optimize edilmiş bir web sitesi
sunulmasını sağlar. Çerezler kişisel verileri içermedikleri için tek başlarına
kimliğinizi belirlemek için kullanılamaz.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Hangi çerezler kullanılmaktadır?</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Çerezler, sahipleri, kullanım
ömürleri ve kullanımları amaçları nezdinde sınıflandırılmaktadır.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Sahibine göre, portal çerezleri ve
üçüncü taraf çerezler kullanılmaktadır. Portal çerezleri OtoSor tarafından
yönetilirken üçüncü taraf çerezler ise OtoSor haricinde farklı firmalar
tarafından yönetilmektedir.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Kullanım ömrüne göre, oturum
çerezleri ve kalıcı çerezler kullanılmaktadır. Oturum çerezlerinde ziyaretçinin
web sitemizi terk etmesi ile verileri silinecektir. Kalıcı çerezlerde ise
veriler ziyaretçilerin cihazlarında kalmaktadır.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Kullanım amaçlarına göre, web
sitesinde teknik çerezler, doğrulama çerezleri, reklam çerezleri,
kişiselleştirme çerezleri ve analitik çerezler kullanılmaktadır.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Neden çerez kullanıyoruz?</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Çerezler, aşağıda belirtilen temel
amaçlar için kullanılmaktadır:</span></p>

        <ol style='margin-top:0cm' start=1 type=1>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Reklam faaliyeti
     gerçekleştirmek,</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Web sitemizin kullanımı
     hakkında bilgi depolamak ve kullanım kolaylığı sağlamak,</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Web sitemizin çalışması için
     gerekli temel fonksiyonları gerçekleştirmek.</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Web sitemizi analiz etmek,
     performansını ve işlevselliğini artırmak.</span></li>
        </ol>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Bazı çerezler, aşağıda belirtilen
tedarikçi olarak kullanmayı seçtiğimiz üçüncü taraflarca ayarlanır:</span></p>

        <ol style='margin-top:0cm' start=1 type=1>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Adobe Analytics (izleme)</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Google Analytics (siteden
     çıkış akışının izlenmesi)</span></li>
            <li class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
     115%;background:white'><span style='font-size:12.0pt;line-height:115%;
     font-family:"Source Sans Pro","sans-serif"'>Facebook</span></li>
        </ol>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Çerezler nasıl engellenir /
silinir?</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Tarayıcıların pek çoğu, varsayılan
olarak çerezleri kabul eder, ancak tarayıcı ayarlarınızı çerezleri kabul
etmemek üzere değiştirebilir veya çerezleri sisteminizden silebilirsiniz. Çoğu
tarayıcı, bir ziyaretten sonra çerezlerin daima silindiği bir moda izin verir.
Hangi tarayıcıyı kullandığınıza bağlı olarak, ayarın farklı bir adı vardır.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Bu modun ayarlanması veya
çerezlerin silinmesi hakkında daha detaylı bilgi için lütfen tarayıcınızın
yardım bölümünü okuyun.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Kullanıcılar Hangi Haklara Sahip?</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Kullanıcıların 6698 Sayılı Kişisel
Verilerin Korunması Kanunu kapsamındaki hakları ilişkin aydınlatma formunda
belirtilmektedir.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><b><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>Rıza ve Politika'daki Değişiklikler</span></b></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;line-height:
115%;background:white'><span style='font-size:12.0pt;line-height:115%;
font-family:"Source Sans Pro","sans-serif"'>OtoSor, Politika hükümlerini
dilediği zaman değiştirebilir. Güncel Politika web sitesinde yayımlandığı tarihte
yürürlük kazanır.</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%;background:white'><span
                style='font-size:12.0pt;line-height:115%;font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:6.0pt;line-height:115%'><span
                style='font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

    </div>
</div>`;